import { create } from "zustand";

const useMobileStore = create((set) => ({
	isMobile: window.innerWidth <= 768,
	isTablet: window.innerWidth <= 1024 && window.innerWidth > 768,
	windowWidth: window.innerWidth,

	setIsMobile: (value) => set({ isMobile: value }),
	setIsTablet: (value) => set({ isTablet: value }),
	setWindowWidth: (width) => set({ windowWidth: width }),

	updateDimensions: () => {
		const width = window.innerWidth;
		set({
			windowWidth: width,
			isMobile: width <= 768,
			isTablet: width <= 1024 && width > 768,
		});
	},

	initialize: () => {
		window.addEventListener(
			"resize",
			useMobileStore.getState().updateDimensions,
		);
		return () => {
			window.removeEventListener(
				"resize",
				useMobileStore.getState().updateDimensions,
			);
		};
	},
}));

export default useMobileStore;
